import React, { Component } from "react";
import ApiRequest from "../libs/request.js";
import Recaptcha from "./shared/Recaptcha";
import * as EmailValidator from 'email-validator';
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

class SignUp extends Component {
  constructor(props) {
    super(props);
    this.email = React.createRef();
    this.password = React.createRef();
    this.password_confirmation = React.createRef();
    this.errorsPanel = React.createRef();
    this.token = React.createRef();
    this.first_name = React.createRef();
    this.last_name = React.createRef();
    this.profilePhoto = React.createRef();
    this.recaptcha = React.createRef();
    this.state = {
      errors: [],
      profilePhotoFile: null,
      isLoading: false,
      showInfoModal: false,
      recaptchaToken: null
    };
  }

  handleRecaptchaChange = (token) => {
    this.setState({ recaptchaToken: token });
  }

  resetRecaptcha() {
    if (this.recaptcha.current) {
      this.recaptcha.current.reset();
    }
  }

  toggleInfoModal = () => {
    this.setState(prevState => ({
      showInfoModal: !prevState.showInfoModal
    }));
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <div className="modern-signup-container">
          <div className="signup-content">
            {/* Left Panel - Intro Text */}
            <div className="signup-intro-panel">
              <div className="intro-content">
                <h1 className="intro-title">Join FilmFuse</h1>
                <p className="intro-subtitle">The Creative Platform for Modern Filmmakers</p>
                <p className="intro-text">
                  Connect with filmmakers, producers, screenwriters, and composers worldwide. Access a film market, monetized streaming service, production management tools, and the ultimate job board for the film industry.
                </p>
                <div className="intro-features">
                  <div className="feature-item">
                    <span className="feature-icon">🎬</span>
                    <span className="feature-text">Film Market & Networking</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-icon">💰</span>
                    <span className="feature-text">Monetized Streaming</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-icon">📋</span>
                    <span className="feature-text">Production Management</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-icon">💼</span>
                    <span className="feature-text">Job Board & Opportunities</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Panel - Form */}
            <div className="signup-form-panel">
              <div className="form-wrapper">
                <div className="form-header">
                  <img
                    src="/images/filmfuse-logo.png"
                    className="signup-logo"
                    alt="FilmFuse"
                  />
                  <h2 className="form-title">Create Your Account</h2>
                  <p className="form-subtitle">Start your creative journey in minutes</p>
                </div>

                <form className="modern-signup-form">
                  <div className="form-errors" ref={this.errorsPanel}></div>

                  {/* More Info Button - Mobile Only */}
                  <button
                    type="button"
                    className="mobile-info-btn"
                    onClick={this.toggleInfoModal}
                  >
                    ℹ️ More Info
                  </button>

                  {/* Name Fields Row */}
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="firstName">First Name *</label>
                      <input
                        type="text"
                        id="firstName"
                        placeholder="Your first name"
                        required
                        ref={this.first_name}
                        className="form-input"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="lastName">Last Name *</label>
                      <input
                        type="text"
                        id="lastName"
                        placeholder="Your last name"
                        required
                        ref={this.last_name}
                        className="form-input"
                      />
                    </div>
                  </div>

                  {/* Email Field */}
                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      placeholder="you@example.com"
                      required
                      ref={this.email}
                      className="form-input"
                    />
                  </div>

                  {/* Password Fields Row */}
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="password">Password *</label>
                      <input
                        type="password"
                        id="password"
                        placeholder="Min. 8 characters"
                        required
                        ref={this.password}
                        className="form-input"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="confirmPassword">Confirm Password *</label>
                      <input
                        type="password"
                        id="confirmPassword"
                        placeholder="Confirm password"
                        required
                        ref={this.password_confirmation}
                        className="form-input"
                      />
                    </div>
                  </div>

                  {/* Profile Photo Upload */}
                  <div className="form-group">
                    <label>Profile Picture *</label>
                    <input
                      type="file"
                      accept="image/*"
                      ref={this.profilePhoto}
                      onChange={this.handleProfilePhotoChange.bind(this)}
                      style={{
                        position: "absolute",
                        opacity: 0,
                        width: 0,
                        height: 0
                      }}
                      id="profilePhotoInput"
                    />
                    <label htmlFor="profilePhotoInput" className="photo-upload-label">
                      <div className="photo-upload-content">
                        {this.state.profilePhotoFile ? (
                          <>
                            <span className="upload-icon">✓</span>
                            <div className="upload-text">
                              <p className="upload-filename">{this.state.profilePhotoFile.name}</p>
                              <p className="upload-hint">Click to change</p>
                            </div>
                          </>
                        ) : (
                          <>
                            <span className="upload-icon">📷</span>
                            <div className="upload-text">
                              <p className="upload-title">Upload Profile Picture</p>
                              <p className="upload-hint">JPG, PNG up to 5MB</p>
                            </div>
                          </>
                        )}
                      </div>
                    </label>
                  </div>

                  {/* Google reCAPTCHA */}
                  <div className="form-group recaptcha-group">
                    <Recaptcha
                      ref={this.recaptcha}
                      onChange={this.handleRecaptchaChange}
                    />
                  </div>

                  {/* Submit Button */}
                  <button
                    className="signup-submit-btn"
                    onClick={this.handleSignupClick.bind(this)}
                    type="button"
                    disabled={this.state.isLoading || !this.state.recaptchaToken}
                  >
                    {this.state.isLoading ? (
                      <>
                        <span className="loading-spinner"></span>
                        Creating Account...
                      </>
                    ) : (
                      "Create Account"
                    )}
                  </button>

                  {/* Footer Links */}
                  <div className="form-footer">
                    <p className="login-link">
                      Already have an account? <a href="/login">Sign In</a>
                    </p>
                    <div className="legal-links">
                      <a href="/terms-conditions">Terms & Conditions</a>
                      <span className="separator">•</span>
                      <a href="/privacy">Privacy Policy</a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          {/* Info Modal - Mobile Only */}
          {this.state.showInfoModal && (
            <div className="signup-modal-backdrop" onClick={this.toggleInfoModal}>
              <div className="signup-modal-content" onClick={(e) => e.stopPropagation()}>
                <button
                  className="signup-modal-close"
                  onClick={this.toggleInfoModal}
                >
                  ✕
                </button>
                <div className="signup-modal-body">
                  <h1 className="intro-title">Join FilmFuse</h1>
                  <p className="intro-subtitle">The Creative Platform for Modern Filmmakers</p>
                  <p className="intro-text">
                    Connect with filmmakers, producers, screenwriters, and composers worldwide. Access a film market, monetized streaming service, production management tools, and the ultimate job board for the film industry.
                  </p>
                  <div className="intro-features">
                    <div className="feature-item">
                      <span className="feature-icon">🎬</span>
                      <span className="feature-text">Film Market & Networking</span>
                    </div>
                    <div className="feature-item">
                      <span className="feature-icon">💰</span>
                      <span className="feature-text">Monetized Streaming</span>
                    </div>
                    <div className="feature-item">
                      <span className="feature-icon">📋</span>
                      <span className="feature-text">Production Management</span>
                    </div>
                    <div className="feature-item">
                      <span className="feature-icon">💼</span>
                      <span className="feature-text">Job Board & Opportunities</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }

  componentDidUpdate() {
    if (this.state.errors && this.state.errors.length > 0) {
      this.errorsPanel.current.innerHTML = this.state.errors.join(", ");
    }
  }

  handleProfilePhotoChange(e) {
    const file = e.target.files[0];
    if (file) {
      // Validate file is an image
      if (!file.type.startsWith('image/')) {
        toast.error("Please select a valid image file");
        this.profilePhoto.current.value = '';
        this.setState({ profilePhotoFile: null });
        return;
      }
      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        toast.error("Image size should not exceed 5MB");
        this.profilePhoto.current.value = '';
        this.setState({ profilePhotoFile: null });
        return;
      }
      this.setState({ profilePhotoFile: file });
    }
  }

  handleSignupClick() {
    var validator = EmailValidator;

    // Clear previous errors
    this.setState({ errors: [] });

    // Validation
    if (this.first_name.current.value.trim().length < 1) {
      toast.error("Please enter a first name");
      return;
    }

    if (this.last_name.current.value.trim().length < 1) {
      toast.error("Please enter a last name");
      return; 
    }

    if (this.email.current.value.length < 1) {
      toast.error("Please enter an email address");
      return;
    }

    if (!validator.validate(this.email.current.value)) {
      toast.error("Please enter a valid email address");
      return;
    }

    if (this.password.current.value.length < 1) {
      toast.error("Please enter a password");
      return;
    }

    if (this.password_confirmation.current.value.length < 1) {
      toast.error("Please confirm your password");
      return;
    }

    if (this.password.current.value !== this.password_confirmation.current.value) {
      toast.error("Passwords do not match");
      return;
    }

    if (!this.state.profilePhotoFile) {
      toast.error("Please upload a profile picture");
      return;
    }

    if (!this.state.recaptchaToken) {
      toast.error("Please verify that you are not a robot");
      return;
    }

    this.setState({ isLoading: true });

    let params = {
      email: this.email.current.value,
      password: this.password.current.value,
      confirm_password: this.password_confirmation.current.value,
      first_name: this.first_name.current.value,
      last_name: this.last_name.current.value,
      recaptcha_token: this.state.recaptchaToken
    };

    let apiRequest = new ApiRequest("post", "/user/signup");
    apiRequest.send(params, (response) => {
      let result = response;
      if (result.errors) {
        this.setState({ isLoading: false });
        this.resetRecaptcha();
        toast.error(result.message || "Signup failed");
      } else {
        // Signup successful, now auto-login
        toast.info("Account created! Logging you in...");
        this.autoLogin();
      }
    });
  }

  autoLogin() {
    let loginParams = {
      email: this.email.current.value,
      password: this.password.current.value,
    };

    let apiRequest = new ApiRequest("post", "/user/login");
    apiRequest.send(loginParams, (response) => {
      let result = response.data ? response.data : response;
      if (result.errors) {
        this.setState({ isLoading: false });
        toast.error(result.message || "Login failed");
      } else {
        // Login successful, store token
        localStorage.setItem("gorilla-token", result.token);
        localStorage.setItem("current_user", JSON.stringify(result.user));
        
        // Small delay to ensure token is stored
        setTimeout(() => {
          toast.info("Uploading profile picture...");
          this.uploadProfilePhoto();
        }, 100);
      }
    }, true); // noToast=true to avoid duplicate toast messages
  }

  uploadProfilePhoto() {
    var formData = new FormData();
    formData.append('profile_photo', this.state.profilePhotoFile);
    // Include first_name and last_name to preserve them during profile photo upload
    formData.append('first_name', this.first_name.current.value);
    formData.append('last_name', this.last_name.current.value);
console.log("formData som", formData)
    let apiRequest = new ApiRequest("post", "/user/update-profile");
    apiRequest.send_file(formData, (response) => {
      let result = response.data ? response.data : response;
      console.log("Profile photo upload result:", result);
      if (result.errors) {
        this.setState({ isLoading: false });
        toast.error(result.message || "Failed to upload profile picture");
      } else {
        this.setState({ isLoading: false });
        toast.success("Account created successfully!");
        // Small delay to show success message before redirect
        setTimeout(() => {
          location.href = "/";
        }, 1000);
      }
    });
  }
}

export default SignUp;
